export default function ChosenCombo($timeout){
  return {
    restrict: "A",
    scope:{
      itemAdd: "&"
    },
    link: function(scope, element, attr){
      var addItem = function(text){
        text = (""+text).trim();
        if(text.length > 0){
          scope.itemAdd({$item: text});
          scope.$apply();
          $timeout(function(){
            element.trigger("chosen:close");
          },1,false);
        }
      }
      var $btn = $("<span class='btn btn-default btn-xs'><i class='fa fa-plus'></span>")
      $btn.on("click", e => {
        addItem(element.next(".chosen-container").find(".chosen-search input").val())
      });

      element.on("chosen:ready", e => {
        element.next(".chosen-container").find(".chosen-search").append($btn)
      });

      element.parent().on("keyup", ".chosen-search input", e => {
        if(e.keyCode == 13 && element.next(".chosen-container").has(".no-results").length){
          addItem(e.target.value);
          e.preventDefault();
        }
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/util/ChosenCombo.js